module.exports = __webpack_public_path__ + "img/f45.9cc1d039.png";